import { IDashboardResponse } from "../../../model/response/dashboard/IDashboardResponse";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDashboardActionsObj =  {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IDashboardResponse,
    LOAD_ERROR: "",
    SET_SELECTED_LAN_XET: 0 as number,
    SET_SELECTED_NAM_XET: "" as string,
}

export const eDashboardActionIds = generateActionTypeIds(eDashboardActionsObj,"DASHBOARD");
export type IDashboardActionTypes = IGenericActionType<typeof eDashboardActionsObj,"DASHBOARD">;